import React from "react";
import "./styles.scss";

interface BeatLoaderProps {
  size?: number;
  color?: string;
  spacing?: number;
  width?: number;
  height?: number;
  border?: number;
}

const BeatLoader: React.FC<BeatLoaderProps> = ({
  size = 16,
  color = "green",
  spacing = 8,
}) => {
  return (
    <div className="beat-loader" style={{ gap: `${spacing}px` }}>
      <div style={{ width: size, height: size, backgroundColor: color }}></div>
      <div style={{ width: size, height: size, backgroundColor: color }}></div>
      <div style={{ width: size, height: size, backgroundColor: color }}></div>
    </div>
  );
};

export default BeatLoader;
